// userProfile lives in shared/pages so the marketplace standalone
// surface can mount the same page without depending on
// workspace-project. Re-exporting keeps existing pages-index imports
// stable.
//
// Bare shared-library import, not a deep pages/userProfile.js subpath — see
// components/UserProfile.js's identical fix note (tickets/execution-
// board.md §1 P0). Read inside a `lazyPage` loader, never at module scope:
// a direct module-scope read is a stub-phantom-value under frank
// (WS-SHARED-LAZYPAGE-HOLLOW-ROUTES-SWITCH-1), and deferring into the
// loader also sidesteps the identity-index.js → pages/admin/* import-cycle
// hazard the old module-scope read hit live ("Cannot destructure property
// 'userProfile' of '...default.pages' as it is undefined", smbls push) —
// by the time a route actually mounts, every module has finished init.
//
// The wrapper's `metadata` asks the page's OWN title logic at call time, the
// same way (pages/index.js `profile`): a pane title, a first paint and the AI
// route chip read the route's def, never the mounted page — with none, the
// chip read the segment-cased path, "User" in a Georgian session.
import _wsShared from '@symbo-ls/workspace-shared'
import { lazyPage } from './lazyPage.js'
export const userProfile = lazyPage(
  () => Promise.resolve(_wsShared.pages.userProfile),
  (el, s) => _wsShared.pages.userProfile.metadata(el, s)
)
